"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _log = _interopRequireDefault(require("../shared/log"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A handle on a subscription to a domain. Allows to close said subscription.
 * The class must be initiated with `await subscription.init()`
 * @alias module:Subscription
 */
var Subscription = /*#__PURE__*/function () {
  function Subscription(listener, initializeFn) {
    _classCallCheck(this, Subscription);

    _defineProperty(this, "open", true);

    _defineProperty(this, "pendingClose", false);

    this.listener = listener;
    this.initializeFn = initializeFn;
  }

  _createClass(Subscription, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.initializeFn(this, function (closeFn) {
                  _this.closeFn = closeFn;

                  if (_this.pendingClose) {
                    _this.close();
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
    /**
     * Close the subscription. The corresponding listener function will stop being called
     * when the domain state is updated.
     * (Idempotent)
     */

  }, {
    key: "close",
    value: function close() {
      if (this.open) {
        if (this.closeFn) {
          this.closeFn();
          this.open = false;
        } else {
          this.pendingClose = true;
        }
      } else {
        (0, _log["default"])('Subscription is already closed.');
      }
    }
  }]);

  return Subscription;
}();

var _default = Subscription;
exports["default"] = _default;